import { CharacterAddCondition, CharacterRemoveCondition } from "../actions/CharacterConditionActions";
import { CharacterState } from "../CharacterStore.State";
import { CharacterReducerHelpers } from "./CharacterReducerHelpers";

const addCondition = (state: CharacterState, action: CharacterAddCondition): CharacterState => {
    const { characterId, conditionId } = action;
    const character = state.characters.find(c => c.id == characterId);
    if (character == null) {
        console.error("Attempted to add condition to nonexistent character.")
        return state;
    }

    const newCharacter = {
        ...character,
        conditions: [...character.conditions, conditionId]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const removeCondition = (state: CharacterState, action: CharacterRemoveCondition): CharacterState => {
    const { characterId, conditionId } = action;
    const character = state.characters.find(c => c.id == characterId);
    if (character == null) {
        console.error("Attempted to remove condition from nonexistent character.")
        return state;
    }

    const newCharacter = {
        ...character,
        conditions: character.conditions.filter(c => c != conditionId)
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

export const CharacterConditionReducers = {
    addCondition,
    removeCondition,
}